import { createFileRoute, redirect } from '@tanstack/react-router';

import { env } from '../../../env';

// /comms/rules/$ruleId — the rule editor. `$ruleId='new'` = create form.
// Flag-gated identically to the list route (see rules.tsx).
export const Route = createFileRoute('/_authenticated/comms/rules/$ruleId')({
  beforeLoad: () => {
    if (!env.VITE_COMM_CENTER) throw redirect({ to: '/inbox' });
  },
});
